import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {TournamentCategoryModel} from './tournament-category.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'categoryId',
  organizationId: 'organizationId',
  name: 'name',
  modality: 'modality',
  sort: 'sort',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',

  tournamentCategory: 'tournamentCategory',
};

export class CategoryModel extends Model {
  organizationId!: number;
  name!: string;
  modality!: string;
  sort!: number;
  status!: string;
  createdAt!: Date;
  updatedAt!: Date;

  tournamentCategory?: TournamentCategoryModel;

  static getInstance(data: Params): CategoryModel {
    const model = new CategoryModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'tournamentCategory') {
        (model as Params)[prop] = TournamentCategoryModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }
    return model;
  }
}
